import { useState } from "react";
import { connect } from "react-redux";
import { setUser } from "../../../../store/action/auth";
import HttpService from "../../../../services/http_service/HttpService";
import Http from "../../../../services/http/Http";
import { Danger, Success } from "../../../../components/button";
import { Div, ItemData } from "./style";

const ChangeStatus = (props) => {
  const { data, user, theme, getOrders } = props;

  const [isLoadingSendData, setIsLoadingSendData] = useState(false);

  const handleSubmit = (status) => {
    setIsLoadingSendData(status === 1 ? status : 2);

    HttpService(user?.token)
      .patch(`orders/${data?.id}/satisfaction`, {
        satisfaction: status,
      })
      .then((response) => {
        getOrders();
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setIsLoadingSendData(false);
      });
  };

  return (
    <>
      <Div className="d-inline-block mr-2">
        <Div className="mt-1">
          <ItemData className="f-12" theme={theme}>
            سفارش درخواستی شما به دستتان رسید ؟
          </ItemData>
        </Div>
      </Div>
      <Div className="mt-3 mb-2 mx-auto text-center">
        <Success
          containerClass="d-inline-block w-48 ml-1"
          className="d-block"
          title="بله"
          onClick={() => handleSubmit(1)}
          isLoading={isLoadingSendData === 1}
          sizeSpinner={20}
        />
        <Danger
          containerClass="d-inline-block w-48 mr-1"
          className="d-block"
          title="خیر"
          onClick={() => handleSubmit(0)}
          isLoading={isLoadingSendData === 2}
          sizeSpinner={20}
        />
      </Div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, { setUser })(ChangeStatus);
